import { Icons } from '@/utils/Icons';
import React from 'react';

type Props = {
  fullScreen?: boolean;
};

const PageLoader: React.FC<Props> = ({ fullScreen = true }) => {
  return (
    <div
      className={`
        ${fullScreen ? 'fixed inset-0 z-50' : 'w-full h-full'}
        flex items-center justify-center
        bg-shell/70 backdrop-blur-sm
      `}
    >
      <Icons.Loading className="text-4xl animate-spin text-gold" />
    </div>
  );
};

export default PageLoader;
